import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";
import { FiPlus, FiMoreHorizontal, FiCheck } from "react-icons/fi";
import EmployeeFunctionEdit from "./EmployeeFunctionEditModal";
import FunctionEdit from "../Functions/FunctionEditModal";
import DataTable from "components/DataTable";
import { showModal, hideModal } from "actions/modalActions";
import * as employeesActions from "actions/employeesActions";
import { employeesService } from "services";
import { errorFormating } from "utils/utils";
import { isAdmin } from "utils/utils";

class EmployeeFunctions extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewEmployeeFunctionModal =
			this.openNewEmployeeFunctionModal.bind(this);
		this.openEditEmployeeFunctionModal =
			this.openEditEmployeeFunctionModal.bind(this);
		this.openEditFunctionModal = this.openEditFunctionModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.getFunctions = this.getFunctions.bind(this);
	}

	async componentDidMount() {
		await this.getFunctions();
	}

	async getFunctions() {
		const employeeId = this.props.employee.id;
		await this.props.getEmployeeFunctions(employeeId);
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewEmployeeFunctionModal() {
		const { functions, employee } = this.props;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("functions.assignment.assignFunction"),
				style: { width: "350px" },
				content: (
					<EmployeeFunctionEdit
						handleClose={this.closeModal}
						functions={functions}
						employee={employee}
						onDataChanged={this.props.onDataChanged}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditEmployeeFunctionModal(employee_function) {
		const { functions, employee } = this.props;

		this.props.showModal(
			{
				open: true,
				title: this.props.t("functions.assignment.editAssignment"),
				style: { width: "350px" },
				content: (
					<EmployeeFunctionEdit
						employee_function={employee_function}
						employee={employee}
						handleClose={this.closeModal}
						functions={functions}
						onDataChanged={this.props.onDataChanged}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditFunctionModal(employee_function) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("functions.editFunction"),
				style: { width: "400px" },
				content: (
					<FunctionEdit
						function={employee_function.function}
						getFunctions={this.getFunctions}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openDeleteEmployeeFunctionModal(idFunction) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("functions.assignment.deleteAssignment"),
				style: { width: "350px" },
				message:
					this.props.t("functions.assignment.deleteConfirmation"),
				deleteAction: () => this.confirmDelete(idFunction),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openAlertModal(message) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("functions.assignment.deleteError"),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (idFunction) => {
		const response = await employeesService.removeFunction(
			this.props.employee.id,
			idFunction
		);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(
				textError.general || textError.id || this.props.t("functions.assignment.deleteError")
			);
		} else {
			this.getFunctions();
			if (typeof this.props.onDataChanged === "function") {
				this.props.onDataChanged();
			}
			this.closeModal();
		}
	};

	getColumns = () => [
		{
			key: "function",
			header: this.props.t("functions.assignment.headerFunction"),
			sortAccessor: (row) => row.function?.name || "",
			render: (employee_function) => (
				<button
					type="button"
					className="btn-transparent btn-editable"
					onClick={() =>
						this.openEditEmployeeFunctionModal(employee_function)
					}
				>
					{employee_function.function.name}
				</button>
			),
		},
		{
			key: "priority",
			header: this.props.t("functions.assignment.headerPriority"),
			sortAccessor: (row) =>
				row.priority && row.priority !== -1 ? row.priority : null,
			render: (employee_function) =>
				employee_function.priority && employee_function.priority !== -1
					? employee_function.priority
					: "-",
		},
		{
			key: "default",
			header: this.props.t("functions.assignment.headerDefault"),
			sortAccessor: (row) => (row.is_default ? 1 : 0),
			render: (employee_function) =>
				employee_function.is_default ? (
					<FiCheck className="tick-default" />
				) : null,
		},
	];

	renderActions = (employee_function) => (
		<Dropdown>
			<Dropdown.Toggle variant="action">
				<FiMoreHorizontal />
			</Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item
					as="button"
					onClick={() =>
						this.openEditEmployeeFunctionModal(employee_function)
					}
				>
					{this.props.t("functions.assignment.editAssignmentAction")}
				</Dropdown.Item>
				{isAdmin() && (
					<Dropdown.Item
						as="button"
						onClick={() => this.openEditFunctionModal(employee_function)}
					>
						{this.props.t("functions.assignment.editFunctionAction")}
					</Dropdown.Item>
				)}
				<Dropdown.Item
					as="button"
					onClick={() =>
						this.openDeleteEmployeeFunctionModal(employee_function.id)
					}
				>
					{this.props.t("common.delete")}
				</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);

	getContent = () => {
		const rows = this.props.employee_functions || [];

		return (
			<div className="employee-functions-datatable-wrap">
				<DataTable
					tableClassName="table-groups table-employee-functions table-hover"
					tableStyle={{ backgroundColor: "#ffffff" }}
					columns={this.getColumns()}
					rows={rows}
					rowKey={(row) => row.id}
					emptyMessage={this.props.t(
						"functions.assignment.noFunctionsAssigned"
					)}
					actionsColumn={{
						render: this.renderActions,
						className: "td-actions",
						header: (
							<button
								type="button"
								title={this.props.t("functions.assignment.assignFunction")}
								onClick={this.openNewEmployeeFunctionModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>
						),
					}}
				/>
			</div>
		);
	};
	render() {
		return <>{this.getContent()}</>;
	}
}

const mapStateToProps = (state) => {
	return {
		employee_functions: state.employeesReducer.employee_functions,
		user: state.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getEmployeeFunctions: (id) =>
		dispatch(employeesActions.getEmployeeFunctions(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EmployeeFunctions));
